const cometChatConfig = {
    authOnlyApiKey: "340c120cb230b56317d8ed8cfa9def92be76edb3",
    appID: "17402b04c0e35b1",
    region: "us",
    messageHistoryLimit: 10,
    textMessageKey: "ARCLIF_POST_COMMENT",
    internalMessageKey: "ARCLIF_COMET_CHAT_INTERNAL_"
}

export default cometChatConfig